import { BadgeWrapper } from "./Badge.styles";
import { BadgeProps } from "./Badge.types";

export const Badge: React.FC<BadgeProps> = (props) => {
  const { content } = props;
  return <BadgeWrapper {...props}>{content}</BadgeWrapper>;
};
